import React, { useImperativeHandle, useRef, useState } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import DataGrid, { Button, Column, Editing, FilterRow, Form, Lookup, Pager, Paging } from "devextreme-react/data-grid";
import { dataGridErrorHandling } from "../../utils/errorHandling";
import { Item } from "devextreme-react/form";
import { dipendenzeDataSource } from "../../datasources/dipendenzeDataSource";
import 'devextreme-react/text-area';
import { apiConfiguration } from "../../apiConfig";
import { ClientiApi } from "../../data";
import { provinceDataSource } from "../../datasources/provinceDataSource";
import { useTranslation } from 'react-i18next';

type Props = {}

export type DipendenzePopupHandle = {
  show: (idCliente: string) => void,
}

type state = {
  idCliente: string | undefined,
  visible: boolean,
  datasource: any,
  title:string
}

const PopupDipendenze: React.ForwardRefRenderFunction<DipendenzePopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<state>({ idCliente: undefined, visible: false, datasource: null, title:"" }); 

  function hideInfo() {
    setState({ idCliente: undefined, visible: false, datasource: null, title:"" });
  }

  useImperativeHandle(ref, () => ({
    show(idCliente) {
      setState({
        idCliente: idCliente,
        visible: true,
        datasource: dipendenzeDataSource(idCliente),
        title: t('elencosedi')
      });
    }
  }));

   function dataGridInitNewRow(e:any){
     e.data.nome="";
     e.data.indirizzo="";
     e.data.cap="";
     e.data.citta="";
     e.data.provinciaCodice="";
     e.data.provinciaDescrizione="";
     e.data.nazioneCodice="";
     e.data.nazioneDescrizione="";
     e.data.telefono="";
     e.data.mobile="";
     e.data.email="";
     e.data.id=state.idCliente;
   }
  const { t } = useTranslation();

  return (<React.Fragment>

    <Popup
      visible={state.visible}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={false}
      fullScreen={true}
      showTitle={true}
      onHidden={hideInfo}
      title={state.title}
      container=".dx-viewport"
    >
      <Position
        at="center"
        my="center"
        of=""
        collision="fit"
      />
  
      <DataGrid
        className={'dx-card wide-card'}
        dataSource={state.datasource}
        showBorders={false}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        errorRowEnabled={false}
        onRowUpdating={function (e) { e.newData = Object.assign({}, e.oldData, e.newData) }}
        onDataErrorOccurred={dataGridErrorHandling}
        onInitNewRow={dataGridInitNewRow}
      >
        <Editing
          mode="popup"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true}>
          <Popup title="Deposito" showTitle={true} />
          <Form colCount={2}>          
            <Item dataField="nome" isRequired={true} />
            <Item dataField="indirizzo" isRequired={true} />
            <Item dataField="cap" />
            <Item dataField="citta" />
            <Item dataField="provinciaCodice" editorType="dxSelectBox" />
          </Form>
        </Editing>
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector={true} showInfo={true} />
        <FilterRow visible={false} />

        <Column  type='buttons' >
          <Button name="edit" />
          <Button name="delete" />
        </Column>
        <Column dataField={'id'} width={90} hidingPriority={1} allowEditing={false} visible={false} showEditorAlways={false} />
        <Column dataField={'nome'}  caption={t ('nome')}/>
        <Column dataField={'indirizzo'} caption={t ('indirizzo')}/>
        <Column dataField={'cap'} caption={t ('cap')} dataType="number"/>
        <Column dataField={'citta'} caption={t ('citta')}/>
        <Column dataField={'provinciaDescrizione'} caption={t ('provinciaDescrizione')}/>
        <Column dataField={'provinciaCodice'} caption={t ('provinciaCodice')} visible={false} >
          <Lookup dataSource={provinceDataSource()} valueExpr="codice" displayExpr={"descrizione"}/>
        </Column>
      </DataGrid>
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        options={{
          text: t('chiudi') ,
          onClick: hideInfo,
        }}
      />
    </Popup>
  </React.Fragment>
  );
}

export default React.forwardRef(PopupDipendenze);
